import React, { Component } from 'react';
import '../../../styles/variables.css';
import {Row, Col} from 'react-bootstrap';
import logo from '../../../images/Home Page.png';
import google_i from '../../../images/google.png';
import github_i from '../../../images/github.png';
import amazon_i from '../../../images/amazon.png';
import basecamp_i from '../../../images/basecamp.jpg';
import invision_i from '../../../images/invision.jpg';
import leftImage from '../../../images/LeftImage.png';
import '../../../styles/components/content.css';
import '../../../styles/components/header.css';
import {ShowNotification} from '../../../components/HandleNotifications';
import {NotificationContainer} from 'react-notifications';
import axios from 'axios';
import {firebase} from '../../../firebase/firebase';
import database from '../../../firebase/firebase';
import Header from '../../../components/Header';
import Footer from '../../../components/Footer';
import {Link} from 'react-router-dom';
import Loader from '../../../components/loader';
axios.defaults.headers.post.Accept = "application/json";
axios.defaults.headers["Content-Type"] = "application/json";
axios.defaults.headers["Access-Control-Allow-Origin"] = "*";
axios.defaults.headers["Access-Control-Allow-Methods"] = "ET, POST, PUT, DELETE";
axios.defaults.headers["Access-Control-Allow-Headers"] = "Authorization";

class Content extends Component {
    
    state = {
        showMessage: false,
        error: "",
        showPassword: false,
        goLogin: false,
        message: '' ,
        loader: false,
        password: '',
        user: {
            name: '',
            lastName: '',
            email: '',
            locationName: '-----',
            cv: '-----',
            career: '-----',
            expertise: '-----',
            phoneNumber: '-----',
            experience: '-----',
            existCv: false,
            aboutMe: '-----',
            id: ''
        }
    };
    handleInputChange = (e) => {
        const name = e.target.name;
        const value = e.target.value;
        if(name === "password"){
            this.setState({password: value})
        }else{
            this.setState(prevState => ({
                user:{
                    ...prevState.user,
                    [name] : value 
                }                           
            }));
        }
    }  
    clearInputs = ()=>{
        this.setState({password: '', user: {
            name: '',
            email: '',
            locationName: '',
            cv: false,
            career: '',
            expertise: '',
            phoneNumber: '',
            experience: '',
            lastName:'',
            existCv: false
        }})
    }

    handleErrors = (error) => {
        let m =''
        switch (error.code) {
            case 'auth/invalid-email':
                m = 'Error en el correo';
                this.setState({message: 'El correo que proporcionaste no tiene un formato valido, por favor verificalo.'});
                break;
            case 'auth/email-already-in-use':
                m = 'Correo en uso';
                this.setState({message: 'El correo que proporcionaste esta actualmente en uso, si ya tienes una cuenta por favor Inicia Sesion',
                    goLogin: true});
                break;
            case 'auth/weak-password':
                m = 'La contraseña es muy corta';
                this.setState({message: 'La contraseña debe de ser de al menos seis caracteres, por favor introduce una nueva e intantalo de nuevo.', goLogin: false});
                break;
            default:
                m=error.code
                this.setState({message: error.message, goLogin: false});
                break;
        }
        return m;
    } 
    handleSubmit = () => {
        const {password} = this.state;
        let email = this.state.user.email;
        firebase.auth().createUserWithEmailAndPassword(email, password).then((user)=>{
            if(user){
                this.setState(prevState => ({
                    user : {
                        ...prevState.user,
                        id: user.user.uid
                    }
                }));
                axios.request({
                    url: "https://us-central1-universia-dev.cloudfunctions.net/type",
                    method: "POST",
                    data: {email: email, type: "student"},
                    crossDomain: true
                }).then(res => {
                    if(!!res.data.code){
                        let message = this.handleErrors(res.data);
                        this.setState({loader: false})
                        this.setState({showMessage : true, error : res.data.code});
                        ShowNotification('error', message, 'Algo salio mal');
                    }else{
                        this.setState({loader: false})
                        firebase.auth().currentUser.sendEmailVerification();
                        database.collection(`users`)
                        .doc(`${res.data}`)
                        .set(this.state.user, {merge: true}).then(()=>{
                            this.setState({showMessage : true, 
                            message: 'Se ha enviado un link de verificacion al correo proporcionado verificalo e ', 
                            goLogin: true});
                        }).then(()=>{
                            ShowNotification('success', 'Se registro exitosamente', 'Listo!');
                            this.clearInputs();
                        });
                    }
                })
            } 
        }).catch((err) => {
            if(err){
                let message = this.handleErrors(err);
                this.setState({showMessage : true, loader: false, error : err});
                ShowNotification('error', message, 'Algo salio mal');
            }
        })
    }
    emailValidation = () => {
        this.setState({loader : true});
        let re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
        if(re.test(this.state.user.email)){
            if(this.state.user.email.indexOf("@udlap.mx", this.state.user.email.length - "@udlap.mx".length) !== -1){
                this.handleSubmit()
            }else{
                this.setState({loader: false})
                this.setState({showMessage : true, message : "Solo pueden registrarse los alumnos y egresados de la UDLAP."});
                ShowNotification("warning", "Usa tu correo institucional. Ejemplo: Pedro@udlap.mx", "Correo electrónico no asociado");
            }
        }else{
            this.setState({loader: false})
            this.setState({showMessage : true, message : 'El correo que proporcionaste no tiene un formato valido, por favor verificalo.'});
            ShowNotification("warning", "Ingresa un correo valido", "Correo electrónico invalido");
        }
    }
    togglePassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    }
    
    render(){
        return(
            <div>
                {this.state.loader ?  <div className="loader"><Loader text={"Estamos creando tu cuenta ..."} active={this.state.loader}/></div> :
                <div className="container">
                    <Row>
                        <Header {...this.props}/>
                    </Row>
                    <Row>
                        <Col xs={6} sm={5} md={5} lg={6} xl={6}>
                            <div className="more">
                                <p className="intro-text">
                                    Tu primera experiencia debe ser el inicio de algo grande. 
                                    Y nada mejor que aprender de compañías TOP.  
                                </p>
                                <button className="more-button">
                                    <Link to="/signup" className="no-decoration">Conoce más</Link>
                                </button>
                            </div>
                        </Col>
                        <Col xs={6} sm={7} md={7} lg={6} xl={6}>
                            <img alt="" className="image" src={logo} />
                        </Col>
                    </Row>
                    <Row className="companies">
                        <Col xs={12} sm={12} md={12} lg={12}>
                            <p className="text-companies">Trabaja en estas empresas</p>
                        </Col>
                    </Row>
                    <Row className="companies">
                        <Col xs={8} sm={8} md={8} lg={8} className="companies-links">
                            <img alt="" className="company" src={google_i}/>
                            <img alt="" className="company" src={amazon_i}/>
                            <img alt="" className="company" src={github_i}/>
                            <img alt="" className="company" src={basecamp_i}/>
                            <img alt="" className="company" src={invision_i}/>
                        </Col>
                    </Row>
                    <Row className="companies categories">
                        <Col xs={10} sm={10} md={10} lg={10} className="companies-links">
                            <button className="c-category shadow" type="button">Sales</button>
                            <button className="c-category shadow" type="button">Ingeniería</button>
                            <button className="c-category shadow" type="button">Marketing</button>
                            <button className="c-category shadow" type="button">Diseño</button>
                            <button className="c-category shadow" type="button">Operaciones</button>
                        </Col>
                    </Row>
                    <Row className="end-page">
                        <Col className="p-none" xs={12} sm={6} md={6} lg={6} xl={6}>
                            <img alt="" className="image" src={leftImage} />
                        </Col>
                        <Col xs={12} sm={6} md={6} lg={6} xl={6}>
                            <p className="text-companies title-account">Una nueva bolsa de trabajo para un mejor futuro</p>
                            <div className="links-option">
                                <label className="option option-active">Soy estudiante</label>
                                <label className="option">Soy empresa</label>
                            </div>
                            <div className="card card-active">
                                <div className="mini-card card-active">
                                    <p className="title-mini-card">
                                        <span role="img" aria-label="emj">🔴</span> Vacantes exclusivas</p>
                                    <p className="text-align">
                                        Todas las ofertas son publicadas por compañías que están 
                                        interesadas por tu talento y comunidad. 
                                    </p>
                                </div>
                                <div className="mini-card">
                                    <p className="title-mini-card">
                                        <span role="img" aria-label="emj">🔸</span> Empresas Top</p>
                                    <p className="text-align">
                                        Trabajamos de la mano con empresas verificadas, 
                                        con excelente ambiente laboral y con posibilidades de crecimiento.
                                    </p>
                                </div>
                                <div className="mini-card">
                                    <p className="title-mini-card">
                                        <span role="img" aria-label="emj">◻️</span> I.A para mejor match</p>
                                    <p className="text-align">
                                        Completa correctamente tu perfil ya que la plataforma 
                                        integra herramientas de Inteligencia Artificial para un mejor match.
                                    </p>
                                </div>
                            </div>
                            <div className="card">

                            </div>
                            <label className="label-input" htmlFor="name">Nombre</label>
                            <input className="input-account shadow" value={this.state.user.name}
                            type="text" name="name" onChange={this.handleInputChange}/>
                            <label className="label-input" htmlFor="name">Apellidos</label>
                            <input className="input-account shadow" value={this.state.user.lastName}
                            type="text" name="lastName" onChange={this.handleInputChange}/>
                            <label className="label-input" htmlFor="email">Correo Institucional</label>
                            <input className="input-account shadow" value={this.state.user.email} 
                            type="email" id="email" name="email" onChange={this.handleInputChange}/>
                            <label className="label-input" htmlFor="password">Contraseña</label>
                            <input className="input-account shadow" value={this.state.password}
                            type={this.state.showPassword ? "text" : "password"} id="password" name="password" onChange={this.handleInputChange}/>
                            <div className="toggle-password-container">
                                <input type="checkbox" className='toggle-password' 
                                onClick={this.togglePassword} id="togglePassword"/>
                                <label className="toggle-password-label" htmlFor="togglePassword">
                                    Mostrar contraseña
                                </label>
                            </div>
                            {this.state.showMessage ? 
                                <p className="go-login-a text-red w-75">{this.state.message}</p>:
                            null}
                            <button className="button-account-g" onClick={this.emailValidation}>Generar cuenta</button>
                        </Col>
                    </Row>
                    <Row>
                        <Footer />
                    </Row>
                </div>}
                <NotificationContainer />
            </div>
        );
    }
}

export default Content;